import { Box, Text, Image, Icon } from "@chakra-ui/react";
import { FaQuoteLeft } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

import Testimonial1 from "../../assets/homeImage/avatar1.png";
import Testimonial2 from "../../assets/homeImage/avatar2.png";
import Testimonial3 from "../../assets/homeImage/avatar3.png";
import SahilImg from "../../assets/SAHIL.jpeg";

const testimonials = [
  {
    name: "SHRINIVAS REDDY",
    image: Testimonial1,
    rating: 5,
    text: `A good friend of mine introduced me to Winnsta Private Limited. And since then I'm regularly playing here for two reasons: 1. I experienced fair game play 2. My money is 100% safe & secure.`,
  },
  {
    name: "BARKHA SHARMA",
    image: Testimonial2,
    rating: 5,
    text: `A good friend of mine introduced me to Winnsta Private Limited. And since then I'm regularly playing here for two reasons: 1. I experienced fair game play 2. My money is 100% safe & secure.`,
  },
  {
    name: "RAHUL VERMA",
    image: Testimonial3,
    rating: 5,
    text: `A good friend of mine introduced me to Winnsta Private Limited. And since then I'm regularly playing here for two reasons: 1. I experienced fair game play 2. My money is 100% safe & secure.`,
  },
  {
    name: "SAHIL",
    image: SahilImg,
    rating: 5,
    text: `Winnsta ek achha game hai mai isme 3000 rupees ka tornament win kiye hai. Brother and sister is game ko download karo aur khelo sab gift card voucher milega.`,
  },
];

const TrendingStories = () => {
  const loopedTestimonials = [...testimonials, ...testimonials];

  return (
    <Box
      py={{ base: 16, md: 24 }}
      px={4}
      bg="#08080A"
      position="relative"
      overflow="hidden"
      sx={{
        ".swiper": {
          overflow: "visible !important",
        },
        ".swiper-pagination": {
          textAlign: "center",
          bottom: "10px !important",
        },
        ".swiper-pagination-bullet": {
          width: "10px",
          height: "10px",
          background: "#FFFFFF",
          opacity: "0.2",
          borderRadius: "999px",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          margin: "0 6px",
          display: "inline-block",
        },
        ".swiper-slide": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "auto",
          transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
          opacity: "0.3",
          transform: "scale(0.85) translateY(20px)",
          filter: "blur(2px)",
        },
        ".swiper-slide-active": {
          opacity: "1",
          transform: "scale(1.1) translateY(0) !important",
          zIndex: 10,
          filter: "blur(0)",
        },
        ".swiper-pagination-bullet-active": {
          width: "28px",
          background: "#A78BFA",
          opacity: "1",
          borderRadius: "999px",
        },
      }}
    >
      {/* Decorative Background Elements */}
      <Box
        position="absolute"
        top="-10%"
        left="-5%"
        w="400px"
        h="400px"
        bg="rgba(139, 92, 246, 0.15)"
        filter="blur(120px)"
        borderRadius="full"
        zIndex={0}
      />
      <Box
        position="absolute"
        bottom="-10%"
        right="-5%"
        w="500px"
        h="500px"
        bg="rgba(217, 70, 239, 0.1)"
        filter="blur(150px)"
        borderRadius="full"
        zIndex={0}
      />

      <Box position="relative" zIndex={1}>
        {/* Section Heading */}
        <Box textAlign="center" mb={16}>
          <Text
            display="inline-block"
            px={4}
            py={1}
            borderRadius="full"
            bg="rgba(139, 92, 246, 0.1)"
            border="1px solid rgba(139, 92, 246, 0.2)"
            color="#A78BFA"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="widest"
            textTransform="uppercase"
            mb={4}
          >
            Testimonials
          </Text>
          <Text
            fontWeight="900"
            fontSize={{ base: "32px", md: "56px" }}
            bgGradient="linear(to-r, #FFFFFF, #A78BFA, #D946EF)"
            bgClip="text"
            lineHeight="1.2"
            mb={4}
          >
            Top Trending Stories
          </Text>
          <Text color="#9CA3AF" fontSize={{ base: "16px", md: "18px" }} maxW="600px" mx="auto">
            Join thousands of winners and experience the most trusted platform in India.
          </Text>
        </Box>

        <Box w="100%" maxW="1400px" mx="auto" position="relative">
          <Swiper
            modules={[EffectCoverflow, Pagination, Autoplay]}
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            speed={1000}
            slidesPerView={3}
            coverflowEffect={{
              rotate: 0,
              stretch: -25,
              depth: 100,
              modifier: 1.5,
              slideShadows: false,
            }}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{ clickable: true }}
            breakpoints={{
              0:   { slidesPerView: 1.2, coverflowEffect: { depth: 50, modifier: 1, stretch: -10 } },
              640: { slidesPerView: 2, coverflowEffect: { depth: 80, modifier: 1.2, stretch: -15 } },
              1024:{ slidesPerView: 3, coverflowEffect: { depth: 100, modifier: 1.5, stretch: -25 } },
            }}
            style={{ paddingBottom: "80px", paddingTop: "80px", width: "100%" }}
          >
            {loopedTestimonials.map((t, idx) => (
              <SwiperSlide key={idx}>
                <Box
                  bg="rgba(255,255,255,0.03)"
                  backdropFilter="blur(16px)"
                  borderRadius="3xl"
                  border="1px solid rgba(255,255,255,0.08)"
                  textAlign="center"
                  w="100%"
                  maxW="400px"
                  position="relative"
                  pt="60px"
                  pb={8}
                  px={8}
                  height="100%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="flex-start"
                  transition="all 0.4s ease"
                  cursor="pointer"
                  _hover={{
                    borderColor: "rgba(139,92,246,0.5)",
                    bg: "rgba(255,255,255,0.05)",
                    transform: "translateY(-8px)",
                  }}
                >
                  {/* Glowing background hint */}
                  <Box
                    position="absolute"
                    inset="0"
                    borderRadius="3xl"
                    bgGradient="radial(circle at top, rgba(139,92,246,0.1) 0%, transparent 70%)"
                    pointerEvents="none"
                  />
                  
                  {/* Background Quote Icon */}
                  <Box position="absolute" top="20px" left="20px" opacity={0.1}>
                    <Icon as={FaQuoteLeft} w="60px" h="60px" color="#8B5CF6" />
                  </Box>
                  
                  {/* Avatar Wrapper */}
                  <Box
                    position="absolute"
                    top="-45px"
                    left="50%"
                    transform="translateX(-50%)"
                    boxSize="90px"
                    borderRadius="full"
                    p="2px"
                    bgGradient="linear(to-br, #8B5CF6, #D946EF)"
                    boxShadow="0 0 30px rgba(139,92,246,0.4)"
                    zIndex={5}
                  >
                    <Box borderRadius="full" overflow="hidden" boxSize="100%" bg="#0C0C0E">
                      <Image
                        src={t.image}
                        alt={t.name}
                        boxSize="100%"
                        objectFit="cover"
                        transform={t.name !== "SAHIL" ? "scale(1.25)" : "none"}
                      />
                    </Box>
                  </Box>

                  {/* Rating Stars */}
                  <Box display="flex" justifyContent="center" gap={1} mb={3}>
                    {[...Array(t.rating)].map((_, i) => (
                      <Icon key={i} viewBox="0 0 24 24" boxSize="14px" color="#FBBF24">
                        <path
                          fill="currentColor"
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                        />
                      </Icon>
                    ))}
                  </Box>

                  {/* Name */}
                  <Text
                    color="white"
                    fontWeight="800"
                    fontSize="lg"
                    letterSpacing="tight"
                    mb={1}
                  >
                    {t.name}
                  </Text>
                  
                  <Text color="#A78BFA" fontSize="xs" fontWeight="bold" letterSpacing="widest" mb={4}>
                    VERIFIED PLAYER
                  </Text>

                  {/* Divider */}
                  <Box
                    w="40px"
                    mx="auto"
                    height="2px"
                    mb={6}
                    bgGradient="linear(to-r, #8B5CF6, #D946EF)"
                    borderRadius="full"
                  />

                  {/* Review */}
                  <Text
                    color="gray.400"
                    fontSize={{ base: "14px", md: "16px" }}
                    lineHeight="1.8"
                    fontFamily="'Barlow', sans-serif"
                    fontStyle="italic"
                    position="relative"
                    zIndex={1}
                  >
                    {t.text}
                  </Text>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Box>
    </Box>
  );
};

export default TrendingStories;
